import React from "react";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Contact from "./components/Contact";
import HeaderAbout from "./components/Header-About";
import Home from "./components/Home";
import HeaderService from "./components/Header-Service";
import AllProducts from "./components/AllProducts";

// ScrollToTop component to handle scroll position
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<HeaderAbout />} />
        <Route path="/service" element={<HeaderService />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/product" element={<AllProducts />} />
      </Routes>

      {/* Footer appears on every page */}
    </div>
  );
}

export default App;
